module.exports = __webpack_public_path__ + "img/002_mac_service.fa17b5e2.png";